import { z } from 'zod'

import {
  DeveloperApiLogStatus,
  DeveloperApiLogMethod,
} from '../constants/developerApiLog'
import { dbEntitySchema, listQueryZodFields } from './system'

export const developerApiLogDataSchema = z.object({
  requestBody: z.string().optional(),
  requestBodyLength: z.number().optional(),
  requestBodyTruncated: z.boolean().optional(),
  responseBody: z.string().optional(),
  responseBodyLength: z.number().optional(),
  responseBodyTruncated: z.boolean().optional(),
  query: z.string().optional(),
  clientIp: z.string().optional(),
  userAgent: z.string().optional(),
  cfRay: z.string().optional(),
})

export const developerApiLogSchema = dbEntitySchema.extend({
  organization: z.string(),
  apiKey: z.string().nullish(),
  apiKeyNote: z.string().nullish(),
  requestId: z.string().nullish(),
  method: z.nativeEnum(DeveloperApiLogMethod),
  path: z.string(),
  statusCode: z.number(),
  durationMs: z.number().min(0),
  status: z.nativeEnum(DeveloperApiLogStatus),
  summary: z.string(),
  data: developerApiLogDataSchema,
})

export const developerApiLogRecordArgsSchema = z
  .object({
    organizationId: z.string(),
    apiKey: z.string().optional(),
    apiKeyNote: z.string().optional(),
    requestId: z.string().optional(),
    method: z.nativeEnum(DeveloperApiLogMethod),
    path: z.string(),
    statusCode: z.number().int().min(200).max(599),
    durationMs: z.number().min(0),
    status: z
      .nativeEnum(DeveloperApiLogStatus)
      .default(DeveloperApiLogStatus.FAILURE),
    summary: z.string(),
    data: developerApiLogDataSchema,
  })
  .superRefine((args, ctx) => {
    if (
      args.statusCode >= 200 &&
      args.statusCode <= 299 &&
      args.status !== DeveloperApiLogStatus.SUCCESS
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '2xx statusCode must use SUCCESS status',
        path: ['status'],
      })
    }

    if (
      args.statusCode >= 400 &&
      args.statusCode <= 599 &&
      args.status !== DeveloperApiLogStatus.FAILURE
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '4xx/5xx statusCode must use FAILURE status',
        path: ['status'],
      })
    }
  })

export const developerApiLogsListQuerySchema = z.object({
  ...listQueryZodFields,
  search: z.string().optional(),
  organizationId: z.string().optional().nullable(),
  statusCode: z.coerce.number().int().optional().nullable(),
  apiKeyId: z.string().optional().nullable(),
  createdStart: z.coerce.date().optional(),
  createdEnd: z.coerce.date().optional(),
})

export const developerApiLogsListResponseSchema = z.object({
  data: z.array(developerApiLogSchema),
})
